// UI translations for this locale. Keys must match the es reference bundle —
// enforced by `npm run check:i18n` (scripts/check-i18n-parity.mjs).
export const en = {
  app: { name: 'bitutravel' },
  nav: {
    home: 'Home',
    search: 'Search',
    login: 'Log in',
    register: 'Sign up',
    dashboard: 'Dashboard',
    reservas: 'Bookings',
    equipo: 'Team',
    logout: 'Log out',
    legal: 'Legal',
    legalNotice: 'Legal notice',
    privacy: 'Privacy policy',
    cookies: 'Cookie policy',
    terms: 'Terms & conditions',
    clientes: 'Clients',
  },
  legal: {
    noticeTitle: 'Legal notice',
    noticeBody:
      'In compliance with Spanish Law 34/2002 (LSSI-CE), this website is owned by bitutravel. Contact email: legal@bitutravel.app. Using the site grants you user status and implies acceptance of these terms.',
    privacyTitle: 'Privacy policy',
    privacyBody:
      'We process your data only to manage your account, bookings and the invoicing required by Spanish law (GDPR and LOPDGDD). We never share your data with third parties for commercial purposes. You can exercise your rights of access, rectification, erasure and portability by writing to privacy@bitutravel.app.',
    cookiesTitle: 'Cookie policy',
    cookiesBody:
      'bitutravel only uses strictly necessary technical cookies: the authentication session and your language preference. We use no advertising or third-party tracking cookies.',
    termsTitle: 'Terms & conditions',
    termsBody:
      'Bookings are requested through the platform and remain subject to the owner\'s approval and the chosen cancellation policy. Corporate invoicing is issued under Spanish law (applicable VAT and IRPF). bitutravel acts as an intermediary between the requesting company and the property owner. Prices shown exclude VAT (21%), which is added to the booking total.',
  },
  landing: {
    heroTitle: 'Corporate accommodation, effortless',
    heroSubtitle:
      'Find quality medium-term stays for your teams across Spain. Trusted by leading companies.',
    checkIn: 'Check-in',
    checkOut: 'Check-out',
    guests: 'Guests',
    search: 'Search',
    featured: 'Featured stays',
    featuredIn: 'Featured in {{city}}',
    guestsValue: '{{count}} guests',
    where: 'Where',
    when: 'When',
    who: 'Who',
    searchDestinations: 'Search destinations',
    addDates: 'Add dates',
    addGuests: 'Add guests',
    howItWorks: 'How it works',
    step1Title: 'Search',
    step1Desc: 'Explore verified accommodation in Spain’s top cities.',
    step2Title: 'Book',
    step2Desc: 'Book medium-term stays for your teams on corporate terms.',
    step3Title: 'Move in',
    step3Desc: 'Your team moves in. We handle the invoice and traveller expense note.',
    perNight: '/ night',
    perNightPlusIva: '/ night + VAT',
    comingSoon: 'Coming soon',
    trustedBy: 'They already trust us',
    testimonialsTitle: 'What our clients say',
    review1Text: 'Since we started using bitutravel, invoices arrive automatically and the whole process is simpler.',
    review1Author: 'María López',
    review1Role: 'Mobility lead, tech consultancy',
    review2Text: 'We manage our whole team\'s accommodation on one platform. The time and cost savings are clear.',
    review2Author: 'Javier Ruiz',
    review2Role: 'Operations director, engineering firm',
    review3Text: 'Corporate invoicing and the traveller expense note come audit-ready. Zero admin work.',
    review3Author: 'Elena García',
    review3Role: 'Finance manager, multinational',
    illustrativeImage: 'illustrative image',
  },
  search: {
    allSpain: 'All Spain',
    allDistricts: 'All districts',
    viewAllResults: 'View all results',
    results: 'results',
    sort: 'Sort',
    sortPriceAsc: 'Price: low to high',
    sortPriceDesc: 'Price: high to low',
    noResults: 'No stays in this area.',
    noResultsForFilters: 'No stays match these filters. Try removing dates or changing the filters.',
    clearFilters: 'Clear filters',
    areaPlaceholder: 'Neighbourhood, area or postcode',
    showMap: 'Map',
    showMore: 'Show more',
    backToTop: 'Back to top',
    typeAll: 'All',
    placeEntire: 'Entire apartment',
    placeRoom: 'Private room',
    placeHotel: 'Hotel',
    dates: 'Dates',
    sortRecommended: 'Recommended',
    size: 'Bedrooms',
    sizeAny: 'Any',
    sizeSingle: '1 bedroom',
    sizeDouble: '2 bedrooms',
    size3plus: '3+ bedrooms',
    rooms: 'Bedrooms',
    units: 'Units',
    grouping: 'Group',
    groupAny: 'Any',
    typeInCity: '{{type}} in {{city}}',
    forNights: 'for {{count}} nights',
    filters: 'Filters',
    groupSameBuilding: 'Same building',
    groupSameArea: 'Nearest available',
    groupSameCategory: 'Same category',
    roomsValue: '{{count}} rm.',
    unitsValue: '{{count}} u.',
    groupResults: 'groups',
    fromPrice: 'from {{price}}',
    unitsInBuilding: '{{count}} units in this building',
    groupUnits: 'units',
    sameBuilding: 'Same building',
    sameArea: 'Nearest available',
    sameCategory: 'Same category',
    anyGroup: 'Units',
    priceFrom: 'from',
    bookAll: 'Book all {{count}}',
    playTour: 'Play tour',
    approxMapNote: 'Locations are approximate. Sign in to see the exact location.',
    pauseTour: 'Pause tour',
    bookAllTitle: 'Book the group',
    bookAllDesc: 'Book all {{count}} units as a single set.',
    bookAllSummary: '{{count}} units · {{nights}} nights',
    bookAllSomeFailed: 'Some units could not be booked.',
    bookAllDone: 'Group booked ({{ok}}/{{count}}).',
    structRoomIn: 'Room in {{building}}',
    structRoomsSameApartment: '{{count}} rooms in the same apartment',
    structRoomsSameBuilding: '{{count}} rooms in the same building',
    structApartmentsSameBuilding: '{{count}} apartments in the same building',
    structStaysSameArea: '{{count}} stays in the same area',
    structStaysSameCategory: '{{count}} stays · {{category}}',
    structUnits: '{{count}} units',
    specFull: '{{guests}} guests · {{bedrooms}} bedrooms · {{baths}} baths',
    specShort: '{{bedrooms}} bed · {{baths}} bath',
  },
  detail: {
    guests: 'guests',
    bedrooms: 'bedrooms',
    bathrooms: 'bathrooms',
    amenities: 'Amenities',
    location: 'Location',
    nights: 'nights',
    cleaningFee: 'Cleaning fee',
    total: 'Total',
    iva: 'VAT ({{pct}}%)',
    ivaNote: 'Prices exclude VAT: 21% VAT is added to the booking total. Compliant corporate invoice.',
    bookNow: 'Book now',
    loginToBook: 'Log in to book',
    signInForDetails: 'Sign in to see full details.',
    approxLocation: 'Approximate location (~700 m radius)',
    checkin: 'Check-in',
    checkout: 'Check-out',
    tooManyGuests: 'This property hosts up to {{capacity}} guests.',
    minStayWarning: 'Minimum stay: {{count}} night | Minimum stay: {{count}} nights',
    nightsWithCount: '{{count}} night | {{count}} nights',
  },
  booking: {
    title: 'Book now',
    subtitle: 'Verify the traveller details. The amount is recomputed on the server.',
    confirm: 'Confirm booking',
    guestName: 'Traveller name',
    guestNamePlaceholder: 'Full name',
    guestNif: 'Traveller NIF',
    datesRequired: 'Select valid dates',
    nameRequired: 'Enter the traveller name',
    nifInvalid: 'Invalid NIF',
    requestCreated: 'Booking created. Awaiting payment.',
    notAvailable: 'Those dates are no longer available.',
    notApproved: 'Your account is not approved to book.',
    createError: 'Could not create the booking. Try again.',
    awaitingDesc: 'Booking created. Make the payment to confirm it.',
    totalWithIva: 'Total (VAT incl.)',
    priceEstimateNote: 'Estimated price: bitutravel calculates the final amount when you book.',
    total: 'Total',
    reference: 'Reference',
    openPaymentLink: 'Open payment link',
    mockDevNote:
      'Development mode: payment is simulated. Click to mark as paid and simulate the Revolut webhook.',
    markPaidDev: 'Mark as paid (dev)',
    markPaidError: 'Could not simulate the payment.',
    paid: 'Payment confirmed',
    paidDesc: 'Your booking is confirmed. You will receive the invoice by email.',
    viewBookings: 'View my bookings',
    paymentStatus: 'Payment',
    bookingsTitle: 'My bookings',
    browseStays: 'Find accommodation',
    summaryTotal: 'Bookings',
    summaryUpcoming: 'Upcoming',
    summaryInstay: 'In stay',
    summarySpend: 'Total spend',
    summaryPendingNote: 'You have {{count}} bookings awaiting payment.',
    payStatusPaid: 'Paid',
    payStatusPending: 'Pending',
    payStatusAwaiting: 'Awaiting payment',
    payStatusRefunded: 'Refunded',
    payStatusFailed: 'Failed',
    payStatusScheduled: 'Scheduled',
    empty: 'You have no bookings yet.',
    statusAwaitingPayment: 'Awaiting payment',
    statusConfirmed: 'Confirmed',
    statusActive: 'Active',
    statusCompleted: 'Completed',
    statusCancelled: 'Cancelled',
    statusDisputed: 'Disputed',
    notFound: 'Booking not found.',
    viewProperty: 'View property',
    cleaningFee: 'Cleaning',
    platformFee: 'bitutravel fee',
    cancelBooking: 'Cancel booking',
    cancelConfirm: 'Are you sure you want to cancel this booking? This cannot be undone.',
    cancelConfirmYes: 'Yes, cancel it',
    cancelledToast: 'Booking cancelled.',
    cancelError: 'Could not cancel the booking.',
    cancelReason: 'Cancellation reason',
    copyLink: 'Copy link',
    tabFuture: 'Upcoming',
    tabPresent: 'Current',
    tabPast: 'Past',
    emptyTab: 'No bookings in this section.',
    purpose: 'Trip purpose',
    purposeLeisure: 'Personal',
    purposeConference: 'Conference / event',
    purposeProject: 'Project',
    purposeRelocation: 'Relocation',
    purposeOther: 'Other',
    eventName: 'Event name',
    eventNamePlaceholder: 'e.g. Mobile World Congress 2026',
    teamSize: 'Travellers',
    teamNotes: 'Team details',
    teamNotesPlaceholder: 'Traveller names, room, notes…',
    teamDetails: 'Trip / team details',
    employee: 'Employee',
    employeePlaceholder: 'Unassigned',
    employeeNone: 'No employee',
    employeeFilterAll: 'All employees',
    employeeCardTitle: 'Assigned employee',
  },
  team: {
    title: 'Team',
    addEmployee: 'Add employee',
    intro: 'Manage your company\'s employees. Assign them to bookings so they receive the stay details by email, or activate them to make their own bookings billed to the company.',
    featureRosterTitle: 'Employee roster',
    featureRosterDesc: 'Name, email, phone and NIF for each employee. Most are recurrent: reused across bookings.',
    featureEmailTitle: 'Details by email',
    featureEmailDesc: 'When you book, assign the employee and they receive the stay details by email.',
    featureActivateTitle: 'Activate to book',
    featureActivateDesc: 'Activate an employee so they log in with their own email and book on behalf of the company.',
    empty: 'No employees yet. Soon you\'ll be able to add them and assign them to your bookings.',
    editEmployee: 'Edit employee',
    editDesc: 'Update the employee\'s contact details.',
    addDesc: 'Add an employee and activate them to log in with their own email.',
    addNote: 'The employee is added to the roster. To let them sign in with their own email, activate their login afterwards.',
    activateLogin: 'Activate login',
    alreadyActivated: 'This employee already has login access.',
    platformUnavailable: 'The service is unavailable right now. Try again later.',
    phone: 'Phone',
    updated: 'Employee updated.',
    added: 'Employee added.',
    emailExists: 'An employee with that email already exists.',
    activated: 'Employee activated.',
    deactivated: 'Employee deactivated.',
    deleted: 'Employee deleted.',
    activate: 'Activate',
    deactivate: 'Deactivate',
    delete: 'Delete',
    deleteTitle: 'Delete employee',
    deleteConfirm: 'Are you sure you want to delete {{name}}? Their account will be removed and this cannot be undone.',
    statusActive: 'Active',
    statusInactive: 'Inactive',
    statusRoster: 'Roster only',
    tempPwTitle: 'Temporary password',
    tempPwDesc: 'This is {{name}}\'s temporary password. Share it with them securely.',
    tempPwWarn: 'It won\'t be shown again. Copy it now.',
    copy: 'Copy',
    copied: 'Copied',
  },
  agency: {
    title: 'Clients',
    intro: 'Manage your agency\'s client companies. Add them with their billing email and book trips on their behalf — the invoice goes to the client company.',
    addClient: 'Add client company',
    clientEmail: 'Company billing email',
    clientEmailPlaceholder: 'invoices@company.com',
    addNote: 'The company must have a bitutravel account and be approved. It is verified when linked.',
    empty: 'You have no client companies yet. Add one to start booking on its behalf.',
    client: 'Client',
    unknownClient: 'Client company',
    unlinkConfirm: 'Are you sure you want to unlink {{name}}? You will no longer be able to book on its behalf.',
    unlinkedBtn: 'Unlink',
    unlinked: 'Client company unlinked.',
    linked: 'Client company linked: {{name}}.',
    notFound: 'No approved company found with that email.',
    billTo: 'Book for',
    selectClient: 'Select a client company',
    noClientsWarn: 'Add a client company in Clients first to be able to book.',
  },

  invoices: {
    title: 'Invoices & expense notes',
    backToBookings: '← My bookings',
    count: 'Invoices',
    baseTotal: 'Net base',
    ivaTotal: 'VAT',
    irpfTotal: 'IRPF withheld',
    total: 'Total invoiced',
    invoicesTitle: 'Invoices',
    ref: 'Booking',
    parteTitle: 'Traveller expense notes',
    parteEmpty: 'No expense notes yet.',
    empty: 'You have no invoices yet. They are generated automatically when a booking is confirmed.',
    regenTitle: 'Re-issue documents',
    regenDesc: 'Regenerate the invoice and traveller expense note for a booking (useful for accounting).',
    regenDone: 'Documents regenerated.',
    regenError: 'Could not regenerate the documents.',
    downloadError: 'Could not download the document.',
    navInvoices: 'Invoices',
    period30: 'Last 30 days',
    period90: 'Last 90 days',
    period365: 'Last 12 months',
    periodAll: 'All time',
    periodEmpty: 'No invoices in this period.',
    exportCsv: 'Export CSV',
    exportZip: 'Download PDFs (ZIP)',
    statusIssued: 'Issued',
    statusPaid: 'Paid',
    statusVoid: 'Void',
  },
  owner: {
    calendar: {
      title: 'Rate calendar',
      subtitle: 'Night-by-night price, minimum stay and availability',
      navButton: 'Rates',
      backendRequired: 'Configure the Supabase backend to use the rate calendar.',
      basePrice: 'Base rate',
      cleaningFee: 'Cleaning',
      applyTitle: 'Apply to selection',
      clearSelection: 'Clear selection',
      selectHint: 'Click one night, then another, to select a range. Each cell is one night — the last marked is the night before checkout.',
      selectedNights: '{{count}} night selected | {{count}} nights selected',
      skipped: '{{count}} night skipped (booked or past) | {{count}} nights skipped (booked or past)',
      noneEditable: 'Every selected night is already booked or in the past.',
      priceLabel: 'New price (€)',
      pricePlaceholder: '€ / night',
      minNightsLabel: 'Minimum stay (nights)',
      minNightsPlaceholder: 'e.g. 5',
      applyPrice: 'Set price',
      applyMinNights: 'Set minimum',
      block: 'Block',
      unblock: 'Open',
      removeOverride: 'Remove override',
      blockNameLabel: 'Block name',
      blockNamePlaceholder: 'e.g. Maintenance, Renovation…',
      saved: 'Calendar updated',
      saveError: 'Could not save the calendar.',
      legend: {
        available: 'Available',
        priced: 'Custom price',
        blocked: 'Blocked',
        booked: 'Booked',
        past: 'Past',
        sunday: 'Sunday',
      },
      ical: {
        title: 'Export calendar (iCal)',
        desc: 'Connect this feed to Airbnb, Booking.com or your channel manager to sync bookings.',
        copy: 'Copy',
        copied: 'Link copied',
        unavailable: 'Feed not available for this property.',
      },
      bulk: {
        from: 'From',
        to: 'to',
        allDays: 'All days',
        weekdays: 'Weekdays',
        weekends: 'Weekends',
        allYear: 'All year round',
        pickDay: 'Pick at least one day of the week',
      },
    },
    revenueTitle: 'Revenue',
    invoicesTitle: 'Invoices & payouts',
    invoicesNote: 'Invoices are generated automatically when a booking is confirmed; payouts settle on bitutravel’s schedule.',
    gross: 'Base (excl. VAT)',
    fee: 'bitutravel fee',
    iva: 'VAT',
    net: 'Net revenue',
    paidOut: 'Paid out',
    pending: 'Pending payout',
    monthlyTitle: 'Revenue by month',
    perPropertyTitle: 'By property',
    property: 'Property',
    bookings: 'Bookings',
    nights: 'Nights',
    payoutsTitle: 'Owner payouts',
    eligibleDesc: 'Confirmed bookings ready to pay out:',
    payNow: 'Pay',
    scheduled: 'Scheduled',
    noPayouts: 'No payouts yet.',
    noData: 'No data yet.',
    payoutDone: 'Payout issued.',
    payoutError: 'Could not issue the payout.',
    range7: '7 d',
    range15: '15 d',
    range30: '30 d',
    range90: '90 d',
    range12m: '12 m',
    rangeAll: 'All',
    payoutConfirmTitle: 'Confirm payout',
    payoutConfirmDesc: 'Issue payout for booking #{{id}} of {{amount}}?',
    confirm: 'Confirm',
    propertiesNav: 'Calendar',
    propertiesTitle: 'Calendar',
    newProperty: 'Add property',
    editProperty: 'Edit',
    propertyUntitled: 'Untitled property',
    propertiesEmpty: "You haven't listed any properties yet.",
    pendingReviewNote: 'New properties stay under review until the bitutravel team approves them. We will email you once approved.',
    pendingEditorNote: 'This property is under review. You can keep editing it; it will appear in search once approved.',
    unpublished: 'Unpublished',
    photoCount: '{{count}} photos',
    noPhotos: 'No photos',
    unitCount: '{{count}} units',
    viewCalendar: 'Calendar',
    viewList: 'List',
    searchUnits: 'Search units…',
    sortName: 'Name',
    sortRecent: 'Recent',
    chipNeedsPhotos: 'Needs photos',
    stripNoBookings: 'No bookings in the next 30 days',
    pms: {
      title: 'Channel manager',
      subtitle: 'Per-unit bookings — drag to move',
      prev: 'Previous',
      next: 'Next',
      today: 'Today',
      view_month: 'Month',
      view_week: 'Week',
      dragHint: 'Drag a booking to another unit or date to move it.',
      moved: 'Booking moved',
      moveError: 'Could not move booking',
      noCity: 'No city',
      cities: 'Cities',
      properties: 'Properties',
      unit: 'Unit',
      overall: 'Overall',
      allProperties: 'All properties',
      noUnits: 'No units yet. Add a property to get started.',
      guest: 'Guest',
      dragHintBlocked: 'Click an empty day to block / open it. Drag a booking to move it; drag its right edge to extend or shorten.',
      addBooking: 'Add booking',
      dates: 'Dates',
      autoRate: 'Automatic rate',
      applyCustomPrice: 'Apply custom price (discount)',
      customPriceHint: 'Edit the total to apply a discount. It is split across the nights.',
      manualBooking: 'Manual booking',
      manualBadge: 'Manual',
      guestName: 'Guest name',
      guestNif: 'Guest NIF',
      guests: 'Guests',
      pricePerNight: 'Price per night',
      checkin: 'Check-in',
      checkout: 'Check-out',
      block: 'Block',
      unblock: 'Open',
      blocked: 'Blocked',
      blockTitle: 'Block night',
      blockNameLabel: 'Name (optional)',
      blockNamePlaceholder: 'e.g. Maintenance',
      blockNameHint: 'Shown on the blocked day.',
      blockConfirm: 'Block',
      manualCreated: 'Manual booking created',
      manualError: 'Could not create manual booking',
      notAvailable: 'Not available for those dates',
      belowMinStay: 'Below the minimum stay for this unit',
      detail: 'Booking detail',
      property: 'Property',
      nights: 'Nights',
      total: 'Total',
      iva: 'VAT',
      fee: 'Platform fee',
      payout: 'Payout',
      channel: 'Channel',
      status: 'Status',
      statusConfirmed: 'Confirmed',
      statusActive: 'In stay',
      statusPending: 'Pending',
      statusAwaiting: 'Awaiting payment',
      statusCancelled: 'Cancelled',
      channelManual: 'Manual',
      channelDirect: 'Direct',
      channelIcal: 'iCal (imported)',
      icalNoPayout: 'External block — no payment',
      confirmMove: 'Confirm move',
      moveFrom: 'From',
      moveTo: 'To',
      moveNote: 'Availability and price are revalidated on confirm.',
      confirm: 'Confirm',
      extendTitle: 'Extend stay',
      shortenTitle: 'Shorten stay',
      newCheckout: 'New check-out',
      extended: 'Stay updated',
      extendError: 'Could not update the stay',
    },
    products: {
      nav: 'Properties',
      title: 'Properties',
      subtitle: 'Rates and channels per unit. The default rate syncs with the property price.',
      empty: 'You have no properties yet.',
      ratePlans: 'Rate plans',
      addRatePlan: 'Add rate plan',
      editRatePlan: 'Edit rate plan',
      ratePlanDesc: 'A rate plan is a sellable offer for this unit (price, cleaning, min stay).',
      noPlans: 'No rate plans yet.',
      planCount: '{{count}} rate plans',
      icalCount: '{{count}} iCal',
      default: 'Default',
      inactive: 'Inactive',
      minNights: 'min {{count}} nights',
      minNightsLabel: 'Minimum nights',
      feePct: '{{pct}}% commission',
      feePctLabel: 'bitutravel commission (%)',
      feePctPlaceholder: 'default',
      feePctHint: 'Empty = global commission. 0 = owner-brought (no commission).',
      makeDefault: 'Default rate',
      name: 'Name',
      basePrice: 'Base price (NET)',
      cleaningFee: 'Cleaning',
      cancellation: 'Cancellation',
      policy: {
        flexible: 'Flexible',
        moderate: 'Moderate',
        strict: 'Strict',
      },
      save: 'Save',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Delete?',
      defaultNoDelete: 'The default rate plan cannot be deleted.',
      created: 'Rate plan created.',
      updated: 'Rate plan updated.',
      deleted: 'Rate plan deleted.',
      channels: 'Channels',
      addChannel: 'Add channel',
      direct: 'Direct',
      noConnections: 'No connections. Add an iCal channel to import an external calendar.',
      icalChannel: 'iCal',
      addIcal: 'Add iCal connection',
      icalDesc: 'Paste the iCal URL of an external calendar (Airbnb, Booking, Google…). Booked dates will block this unit.',
      icalUrl: 'Calendar iCal URL',
      addAndSync: 'Add & sync',
      syncNow: 'Sync',
      syncAll: 'Sync all',
      syncDone: '{{upserted}} imported, {{cancelled}} cancelled, {{conflicts}} conflicts',
      syncAllDone: 'Sync complete: {{upserted}} imported, {{cancelled}} cancelled, {{conflicts}} conflicts',
      syncError: 'Sync error',
      lastSync: 'Last sync',
      neverSynced: 'Not synced yet',
      connectionDeleted: 'Connection deleted.',
      connStatus: {
        pending: 'Pending',
        active: 'Active',
        paused: 'Paused',
        error: 'Error',
      },
      rangeActionTitle: 'Range selected',
      rangeActionHint: 'What do you want to do with these nights?',
      selectHint: 'Click a night and then another (or the same night twice) to pick a range.',
    },

    status: {
      pending: 'Under review',
      approved: 'Published',
      rejected: 'Rejected',
    },
    step1: 'Basics',
    step2: 'Description',
    step3: 'Location & photos',
    backStep: 'Back',
    nextStep: 'Next',
    saveProperty: 'Save property',
    fieldType: 'Accommodation type',
    type: {
      apartment: 'Apartment',
      studio: 'Studio',
      house: 'House',
      room: 'Room',
      loft: 'Loft',
      duplex: 'Duplex',
      cabin: 'Cabin',
      guesthouse: 'Guesthouse',
      hotel: 'Hotel',
      bed_breakfast: 'Bed & breakfast',
    },
    fieldCapacity: 'Capacity (guests)',
    fieldBeds: 'Beds',
    fieldPrice: 'Price per night (€)',
    fieldCleaning: 'Cleaning fee (€)',
    fieldCheckinTime: 'Check-in time',
    fieldCheckoutTime: 'Check-out time',
    fieldTitleEs: 'Title (Spanish)',
    fieldTitleEn: 'Title (English)',
    fieldDescEs: 'Description (Spanish)',
    fieldDescEn: 'Description (English)',
    fieldCity: 'City',
    fieldCategory: 'Category',
    fieldCategoryHint: 'executive, standard, suite…',
    fieldBuilding: 'Building / address',
    fieldUnitLabel: 'Unit label',
    fieldNeighborhood: 'Neighbourhood / district',
    fieldNeighborhoodHint: 'e.g. Chamberí',
    fieldPostalCode: 'Postal code',
    cityPrefillNote: "Picking a city fills the coordinates with its centre; adjust them if you know the exact location.",
    photosAfterCreate: 'Save the property first — then you can add photos.',
    addPhotos: 'Add photos',
    deletePhoto: 'Delete photo',
    photoUploadError: 'Could not upload the photo.',
    photoDeleteError: 'Could not delete the photo.',
    createdToast: 'Property created. It is now under review.',
    savedToast: 'Property saved.',
    saveError: 'Could not save the property.',
    fiscal: {
      title: 'Fiscal data & VeriFactu',
      subtitle: 'Issuer information and authorization for bitutravel to file your invoices with AEAT.',
      statusActive: 'VeriFactu active. Your lodging invoices are filed with AEAT.',
      statusPending: 'VeriFactu pending. Your invoices are issued but not filed with AEAT.',
      statusRevoked: 'Your authorization has been revoked. AEAT filing is paused.',
      active: 'Active',
      pending: 'Pending',
      revoked: 'Revoked',
      issuerTitle: 'Issuer details',
      personaType: 'Person type',
      personaF: 'Individual',
      personaJ: 'Company',
      seriesLodging: 'Invoice series',
      seriesHint: 'AEAT series for your lodging invoices (default O). Do not change it without reason.',
      legalName: 'Legal name',
      nif: 'Tax ID (NIF)',
      country: 'Country',
      street: 'Address',
      postalCode: 'Postal code',
      city: 'City',
      save: 'Save fiscal data',
      saved: 'Fiscal data saved.',
      saveError: 'Could not save fiscal data.',
      errFields: 'Legal name and NIF are required.',
      apoderamientoTitle: 'Power of attorney',
      apoderamientoDesc: 'To file invoices with AEAT on your behalf, bitutravel needs a signed power of representation. Upload the signed power to activate filing.',
      poderOnFile: 'Power of attorney on file:',
      uploadPoder: 'Upload signed power of attorney (PDF)',
      poderHint: 'PDF, max 10 MB.',
      granted: 'Apoderamiento activated. VeriFactu will file your next invoices.',
      grantError: 'Could not register the power of attorney.',
      errPoderSize: 'The file exceeds 10 MB.',
      legalNote: 'By uploading the power of attorney you confirm you have signed the representation authorization for bitutravel to file invoices with AEAT (RD 1007/2023).',
      bannerPending: 'Activate VeriFactu to file your invoices with AEAT.',
      bannerRevoked: 'Your VeriFactu authorization is revoked.',
      bannerCta: 'Set up',
    },

  },
  profile: {
    title: 'Profile & settings',
    navProfile: 'Profile',
    accountSection: 'Account',
    statusLabel: 'Account status',
    rejectionReason: 'Rejection reason',
    detailsSection: 'Billing details',
    languageSection: 'Language',
    localeLabel: 'Preferred language',
    localeHint: 'Saved to your account and applied across your devices.',
    localeSaved: 'Language updated.',
    billingSection: 'Billing & payment',
    invoiceEmail: 'Invoice email',
    invoiceEmailPlaceholder: 'invoices@yourcompany.com',
    ibanTransfer: 'IBAN (pay by transfer)',
    ibanHint: 'If you prefer to pay by bank transfer.',
    preferredMethod: 'Preferred payment method',
    methodCard: 'Card',
    methodTransfer: 'Transfer',
    savedCards: 'Saved cards',
    defaultCard: 'Default',
    billingProcessorNote: 'Card details are tokenized with Revolut; we never store the full number.',
    billingSaved: 'Billing updated.',
  },
  auth: {
    registerTitle: 'Create account',
    loginTitle: 'Log in',
    rolePrompt: 'How will you use bitutravel?',
    roleBook: 'I book stays',
    roleList: 'I list properties',
    roleCompany: 'Company',
    roleAutonomo: 'Freelancer',
    roleOwner: 'Property owner',
    roleEmployeeLabel: 'Employee',
    roleAgencyLabel: 'Agency',
    roleCompanyDesc: 'Centralised reservations for your company',
    roleAutonomoDesc: 'For self-employed professionals',
    roleOwnerDesc: 'Publish and monetise your properties',
    roleBookerPrompt: 'Who is booking?',
    pathManager: 'I manage properties',
    pathManagerDesc: 'List your inventory and manage rates and availability',
    pathBook: 'I book stays',
    pathBookDesc: 'For companies, employees and self-employed guests',
    roleEmployee: 'I work for a company',
    roleEmployeeDesc: 'I book with my company card; the invoice goes to it',
    contactName: 'Contact person',
    email: 'Email',
    fullName: 'Full name',
    legalName: 'Legal name',
    cif: 'CIF (company tax ID)',
    nif: 'NIF / DNI',
    address: 'Address',
    iban: 'IBAN for payouts',
    irpf: 'IRPF retention (%)',
    submit: 'Submit application',
    pendingTitle: 'Application under review',
    pendingDesc: 'Our team is verifying your account. We will email you once approved.',
    pendingApproved: 'Your account has been approved!',
    checkStatus: 'Check again',
    profileErrorTitle: "We couldn't load your profile",
    profileErrorDesc:
      "Your session is valid but we couldn't find your account data. Try again or sign out.",
    rejectedTitle: 'Application rejected',
    rejectedDesc: 'Your application was not approved. Reason: {{reason}}',
    loginPrompt: 'Already have an account? Log in',
    registerPrompt: "Don't have an account? Sign up",
    login: 'Log in',
    magicLink: 'Send magic link',
    magicLinkSent: "We've sent a magic login link to your email. Open it to sign in.",
    cifInvalid: 'Invalid CIF',
    cifInRegistry: 'Found in company directory',
    nifOrCifInvalid: 'Invalid NIF/CIF',
    ibanInvalid: 'Invalid IBAN',
    irpfRange: 'Must be between 7 and 45 %',
    loginErrorGeneric: "Couldn't sign in. Check your email.",
    loginRateLimited: 'Too many attempts. Wait a minute and try again.',
    loginEmailNotConfirmed: 'Confirm your email before signing in.',
  },
  admin: {
    approvalsTitle: 'Approval queue',
    approve: 'Approve',
    reject: 'Reject',
    reason: 'Reason',
    empty: 'No pending applications',
    typeCompany: 'Company',
    typeAutonomo: 'Freelancer',
    typeOwner: 'Owner',
    approvedToast: 'Application approved',
    rejectedToast: 'Application rejected',
    decisionFailed: 'Could not save the decision',
    searchPlaceholder: 'Search by name, email or tax ID',
    tabAll: 'All',
    tabCompany: 'Companies',
    tabAutonomo: 'Freelancers',
    tabOwner: 'Owners',
    confirmApprove: 'Approve {{name}}?',
    confirmReject: 'Reject {{name}}?',
    confirm: 'Confirm',
    reasonRequired: 'Please enter a rejection reason',
    noMatches: 'No matches',
    roleAdmin: 'Administration',
    consoleTitle: 'Admin console',
    navApprovals: 'Approvals',
    navAccounts: 'Accounts',
    navBookings: 'Bookings',
    navInvoices: 'Invoices',
    tabAgency: 'Agencies',
    tabEmployee: 'Employees',
    tabBlocked: 'Blocked',
    typeAgency: 'Agency',
    typeEmployee: 'Employee',
    typeAdmin: 'Admin',
    typeSuperadmin: 'Superadmin',
    statusPending: 'Pending',
    active: 'Active',
    blocked: 'Blocked',
    rejected: 'Rejected',
    block: 'Block',
    unblock: 'Unblock',
    blockedToast: 'Account blocked',
    unblockedToast: 'Account unblocked',
    manageFailed: 'Could not change the account status',
    commissionDefault: 'Default {{pct}}%',
    commissionEdit: 'Edit',
    commissionSave: 'Save',
    commissionCancel: 'Cancel',
    commissionSaved: 'Commission updated.',
    commissionFailed: 'Could not update the commission.',
    lastActions: '{{count}} admin actions recorded',
    noBookings: 'No bookings.',
    noInvoices: 'No invoices.',
    kindCommission: 'Commission',
    kindLodging: 'Lodging',
    vfFiled: 'VeriFactu filed',
    vfIncidence: 'Incidence',
    vfPending: 'VeriFactu pending',
    navRegistry: 'Directory',
    vfSubmit: 'Submit to AEAT',
    vfSubmitted: 'Submitted to AEAT',
    vfSubmitFailed: 'AEAT submission failed',
    vfNotConfigured: 'VeriFactu certificate not configured',
    void: 'Void',
    voidConfirm: 'Void this invoice? If it was filed with AEAT, a cancellation will be sent.',
    voidDone: 'Invoice voided',
    voidFailed: 'Could not void the invoice',
    voidAnulacionPending: 'AEAT cancellation pending certificate',
    voided: 'Voided',
    rect: 'Rectificativa',
    rectConfirm: 'Issue a rectificativa substituting this invoice?',
    rectDone: 'Rectificativa issued',
    rectFailed: 'Could not issue the rectificativa',
    registry: {
      addTitle: 'Add company',
      editTitle: 'Edit company',
      listTitle: 'Company directory',
      cif: 'CIF',
      legalName: 'Legal name',
      street: 'Street',
      postalCode: 'Postal code',
      city: 'City',
      province: 'Province',
      country: 'Country',
      save: 'Save',
      saved: 'Company saved',
      saveError: 'Could not save the company',
      deleted: 'Company removed',
      deleteError: 'Could not remove the company',
      errFields: 'CIF and legal name are required',
      empty: 'No companies in the directory yet',
      edit: 'Edit',
    },
  },
  dashboard: {
    roleLabel: 'Role',
    emailLabel: 'Email',
  },
  notFound: {
    title: 'Page not found',
    desc: "The page you're looking for doesn't exist or has moved.",
  },
  error: {
    boundaryDesc: 'Something went wrong. Reload to continue.',
    boundaryReload: 'Reload',
  },
  common: {
    loading: 'Loading…',
    error: 'Something went wrong',
    favorite: 'Save to favorites',
    required: 'Required',
    back: 'Back',
    retry: 'Retry',
    continue: 'Continue',
    done: 'Done',
    save: 'Save',
    plusIva: '+ VAT',
    cancel: 'Cancel',
    rooms: 'rooms',
    room: 'room',
    bathrooms: 'bathrooms',
    bathroom: 'bathroom',
    increment: 'Increase',
    decrement: 'Decrease',
    edit: 'Edit',
    close: 'Close',
    previous: 'Previous',
    next: 'Next',
  },
  amenities: {
    wifi: 'Wi-Fi',
    parking: 'Parking',
    ac: 'Air conditioning',
    heating: 'Heating',
    washing: 'Washing machine',
    dishwasher: 'Dishwasher',
    elevator: 'Elevator',
    furnished: 'Furnished',
    kitchen: 'Kitchen',
    meeting_room: 'Meeting room',
    printer: 'Printer',
    gym: 'Gym',
  },
} as const
